import {
  useQuery,
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseQueryResult
} from 'react-query'
import { redeemVoucher, fetchVoucherStatus, buyVoucher } from 'api/vouchers'

export function useMutateRedeemVoucher(): UseMutationResult<
  { id: number },
  unknown,
  string
> {
  return useMutation(redeemVoucher)
}

export function useVoucherStatus(
  code: string
): UseQueryResult<{ valid: boolean; amount?: number }> {
  return useQuery(['voucher-status', code], () => fetchVoucherStatus(code), {
    staleTime: 0,
    enabled: code.length > 0
  })
}

export function useMutateBuyVoucher(): UseMutationResult<
  { success: boolean; message: string },
  unknown,
  {
    amount: number
    from_name: string
    from_email: string
    to_name?: string
    to_email?: string
    note?: string
  }
> {
  const qc = useQueryClient()
  return useMutation(buyVoucher, {
    onSuccess: () => {
      qc.invalidateQueries(['wallet'])
    }
  })
}
